import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Wraps a public-or-customer route to redirect admin accounts to /admin.
 * Unlike ProtectedRoute, this does NOT require login — guests can still view
 * the page. Only signed-in admins are redirected away.
 */
export default function AdminBlock({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user?.role === "admin") return <Navigate to="/admin" replace />;
  return children;
}
